/** @typedef {import("../types.ts").MapLayer} MapLayer */

/** @param {MapLayer[]} layers @param {string} id */
export function resolveMapLayer(layers, id) {
    return layers.find((layer) => layer.id === id) ?? layers[0];
}

/** @param {MapLayer} layer @param {number | undefined} y */
export function playerOnMapLayer(layer, y) {
    if (y === undefined) {
        return layer.min_player_y === undefined && layer.max_player_y === undefined;
    }
    return (
        (layer.min_player_y === undefined || y >= layer.min_player_y) &&
        (layer.max_player_y === undefined || y < layer.max_player_y)
    );
}

/** @param {MapLayer[]} layers @param {number | undefined} y */
export function mapLayerForPlayer(layers, y) {
    return layers.find((layer) => playerOnMapLayer(layer, y)) ?? layers[0];
}

/** @param {string} world @param {MapLayer} layer */
export function mapTileUrl(world, layer) {
    return `tiles/${world}/${layer.path ? `${layer.path}/` : ""}{z}/{x}_{y}.png`;
}
